// getNotificationLogColumns.ts
import { t } from "i18next";
import { AppRoles } from "../../data/models/role";
import { hasRolesv2 } from "../../utils/permissionEvaluator";
import { getDateAndTimeFormatByPlatformLanguage } from "../../utils/utils";
import { TenantMenuButton } from "../../_styles/StyledButtons";
import { TableHeader } from "../../_styles/table/TableHeader";
import { TableText } from "../../_styles/table/TableText";
import { NotificationResultLog } from "../../data/models/notificationLog";
import { Column } from "../../components/GenericTable";

interface GetColumnsConfig {
    i18nLang: string;
    selectedUserInstitution: any;
    onPreviewSelect: (event: React.SyntheticEvent<HTMLElement>, logId: string) => void;
}

export function getNotificationLogColumns(config: GetColumnsConfig): Column<NotificationResultLog>[] {
    const {
        i18nLang,
        selectedUserInstitution,
        onPreviewSelect,
    } = config;

    const baseColumns: Column<NotificationResultLog>[] = [
        {
            header: <TableHeader>{t("RECIPIENT_FULL_NAME")}</TableHeader>,
            key: "recipientFullName",
            render: (log) => <TableText>{log.recipientFullName}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("TARGET")}</TableHeader>,
            key: "target",
            render: (log) => <TableText>{log.target}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("TEMPLATE_NAME")}</TableHeader>,
            key: "templateName",
            render: (log) => <TableText>{log.templateName}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("SUBJECT")}</TableHeader>,
            key: "subject",
            render: (log) => <TableText>{log.subject}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("SUCCEEDED")}</TableHeader>,
            key: "succeeded",
            render: (log) => (
                <TableText
                    style={{
                        color: log.succeeded ? "green" : "red",
                        fontWeight: "bold",
                    }}
                >
                    {log.succeeded ? t("SUCCESS") : t("GENERAL_FAILED")}
                </TableText>
            ),
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("LANGUAGE")}</TableHeader>,
            key: "languageId",
            render: (log) => <TableText>{log.languageId}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("CHANNEL")}</TableHeader>,
            key: "channel",
            render: (log) => <TableText>{log.channel}</TableText>,
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("TIMESTAMP")}</TableHeader>,
            key: "timestampUtc",
            render: (log) => (
                <TableText>
                    {getDateAndTimeFormatByPlatformLanguage(new Date(log.timestampUtc), i18nLang)}
                </TableText>
            ),
            className: "process-cell",
        },
        {
            header: <TableHeader>{t("INTERNAL_MESSAGE")}</TableHeader>,
            key: "internalMessage",
            render: (log) => <TableText>{log.internalMessage}</TableText>,
            className: "process-cell",
        },
    ];

    if (
        selectedUserInstitution &&
        hasRolesv2([AppRoles.ADMIN, AppRoles.USZ_COORDINATOR, AppRoles.TENANT_ADMIN], selectedUserInstitution.roles)
    ) {
        baseColumns.push({
            header: <TableHeader>{t("TEMPLATE_CONTENT")}</TableHeader>,
            key: "emailBody",
            render: (log) => (
                <TableText>
                    {log.templateContent && (
                        <TenantMenuButton
                            onClick={(e) => onPreviewSelect(e, log.id)}
                        >
                            {t("GENERAL_VIEW")}
                        </TenantMenuButton>
                    )}
                </TableText>
            ),
            className: "process-cell",
        });
    }

    return baseColumns;
}
